import { bizpost } from "../../ajax";

export async function getReportData(params: {
  reportcode: string;
  period?: string | null;
  cycle?: string | null;
  scenario?: string | null;
  costcenter?: string | null;
  location?: string | null;
  asofdate?: string | null;
}) {
  
  const {reportcode,period,cycle} = params;
  const {scenario,costcenter} = params;
  const {location,asofdate} = params;

  return bizpost({
    s: "reports",
    a: "get",
    mod: reportcode,
    bpc: period,
    bcc: cycle,
    scc: scenario,
    ccc: costcenter,
    lcc: location,
    aod: asofdate,
  });
}